import Vue from 'vue'

export const customerTypes = async function() {
  const results = await Vue.prototype.$apiCall(`query OntarioCustomerTypes {
                                                  ontarioPreferences {
                                                    lcboDirectDeliveryFromDutyPaid
                                                  }
                                                }`,
                                              {});
  if (results.error)
    return [];

  const lcboDirectDeliveryFromDutyPaid = results.data.ontarioPreferences.lcboDirectDeliveryFromDutyPaid;
  return [{header:'ONTARIO'},
                              {text:'LCBO in-bond',value:'LCBOInBond',spirit:false,wine:false,prefInBond:true,prefCases:true},
                              {text:'LCBO duty-paid',value:'LCBODutyPaid',spirit:false,wine:false,
                               prefInBond:!lcboDirectDeliveryFromDutyPaid,prefCases:true},
                              {text:'Licensee',value:'Licensee',spirit:false,wine:false,prefInBond:false,prefCases:false},
                              {text:'Tied house',value:'TiedHouse',spirit:false,wine:false,prefInBond:false,prefCases:false},
                              {text:'By the glass',value:'ByTheGlass',spirit:false,wine:false,prefInBond:false,prefCases:false},
                              {text:'Special Occasion Permit',value:'SpecialOccasionPermit',spirit:false,wine:false,prefInBond:false,prefCases:false},
                              {text:'Contract',value:'Contract',spirit:false,wine:false,prefInBond:true,prefCases:true}];
}
